var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16634 11.2458V12.5791H4.83301V11.2458H2.16634ZM2.16634 8.5791V9.91243H8.83301V8.5791H2.16634ZM6.16634 11.2458V12.5791H8.83301V11.2458H6.16634ZM10.1663 8.5791V9.91243H12.833V8.5791H10.1663ZM10.1663 11.2458V12.5791H12.833V11.2458H10.1663ZM0.833008 13.9124V4.5791L4.16634 7.24577V4.5791L7.49967 7.24577V4.5791L10.833 7.24577L11.4997 0.579102H13.4997L14.1663 7.24577V13.9124H0.833008Z",
    fill: "#163C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientesIcon);
export default __webpack_public_path__ + "static/media/ClientesIcon.6c6e779474e773e552f2e724889e68eb.svg";
export { ForwardRef as ReactComponent };